'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  (function (AnimateToScroll, $) {

    var bindUIActions = function bindUIActions() {
      $(document).on('click', '[data-animate-scroll]', function (e) {
        e.preventDefault();

        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
      });
    };

    AnimateToScroll.init = function () {
      bindUIActions();
    };
  })(window.AnimateToScroll = window.AnimateToScroll || {}, _jquery2.default, undefined);
};